/* wishlist.js — lightweight native wishlist (no app). Stores a compact list in
   localStorage; toggles heart buttons ([data-wishlist-toggle]); keeps the header
   count in sync; and renders the wishlist page (#wishlist-grid) from storage. */
(function () {
  var KEY = 'bib_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    syncCount(list);
    syncHearts(list);
  }
  function has(list, handle) { return list.some(function (i) { return i.handle === handle; }); }

  function syncCount(list) {
    list = list || read();
    var n = list.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
      el.classList.toggle('wl-count--empty', n === 0);
    });
  }
  function syncHearts(list) {
    list = list || read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = has(list, btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var list = read();
    if (has(list, handle)) {
      list = list.filter(function (i) { return i.handle !== handle; });
    } else {
      list.push({
        handle: handle,
        title: btn.getAttribute('data-title') || '',
        url: btn.getAttribute('data-url') || ('/products/' + handle),
        image: btn.getAttribute('data-image') || '',
        price: btn.getAttribute('data-price') || ''
      });
    }
    write(list);
    renderPage(list);
  });

  function renderPage(list) {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    list = list || read();
    var empty = document.getElementById('wishlist-empty');
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (i) {
      return '<div class="wl-card">' +
        '<button type="button" class="wl-heart wl-heart--card is-active" data-wishlist-toggle data-handle="' + esc(i.handle) + '" data-title="' + esc(i.title) + '" data-url="' + esc(i.url) + '" data-image="' + esc(i.image) + '" data-price="' + esc(i.price) + '" aria-label="Remove from wishlist" aria-pressed="true">' + heartSvg() + '</button>' +
        '<a class="wl-card__media" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="wl-card__info"><a class="wl-card__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' + (i.price ? '<span class="wl-card__price">' + esc(i.price) + '</span>' : '') + '</div>' +
        '</div>';
    }).join('');
    syncHearts(list);
  }

  function esc(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function heartSvg() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.1C.6 9 1.7 5.6 4.8 5c2-.4 3.7.6 4.7 2 .3.4.5.7.5.7s.2-.3.5-.7c1-1.4 2.7-2.4 4.7-2 3.1.6 4.2 4 2.8 6.9C19.5 16.4 12 21 12 21z"/></svg>'; }

  // Slide-in drawer (opened from the header heart — no /pages/wishlist needed).
  function setDrawer(open) {
    var d = document.getElementById('wl-drawer');
    if (!d) return open === true ? false : true; // no drawer → let the link navigate
    d.classList.toggle('is-open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) renderPage();
    return true;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wl-open]')) { if (setDrawer(true)) e.preventDefault(); return; }
    if (e.target.closest('[data-wl-close]')) { setDrawer(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  function init() { syncCount(); syncHearts(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
